import { TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var clasificacionComponent = /** @class */ (function () {
    function clasificacionComponent(dialog) {
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            clasificacion: new FormControl(''),
            metro: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("clasificacion"))) {
            localStorage.setItem("clasificacion", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("clasificacion"));
        }
        this.clasificacion = { clasificacion: "", metro: "" };
        this.temp_clasif = { clasificacion: "", metro: "" };
    }
    clasificacionComponent.prototype.add_clasificacion = function () {
        this.actualRow = localStorage.getItem("clasificacion");
        this.rows = JSON.parse(this.actualRow);
        if (!this.form.value.clasificacion && !this.form.value.metro) {
            console.log("no se ingresaron datos");
            this.dialog.open(this.openModalNODATA);
        }
        else {
            this.rows = this.rows.concat({
                clasificacion: this.form.value.clasificacion,
                metro: this.form.value.metro
            });
            localStorage.setItem("clasificacion", JSON.stringify(this.rows));
            this.form.reset();
        }
    };
    clasificacionComponent.prototype.get_clasificacion = function (id) {
        console.log(id);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_clasif.id = id;
                this.temp_clasif.clasificacion = this.rows[x].clasificacion;
                this.temp_clasif.metro = this.rows[x].metro;
                this.dialog.open(this.openModal);
            }
        }
    };
    clasificacionComponent.prototype.cleanData = function () {
        this.temp_clasif = { clasificacion: "", metro: "" };
    };
    clasificacionComponent.prototype.saveclasificacion = function () {
        var id = this.temp_clasif.id;
        console.log(this.temp_clasif);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("clasificacion", JSON.stringify(this.rows));
                $("#clasif_modal").modal("hide");
                this.actualRow = localStorage.getItem("clasificacion");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    clasificacion: this.temp_clasif.clasificacion,
                    metro: this.temp_clasif.metro
                });
                localStorage.setItem("clasificacion", JSON.stringify(this.rows));
                this.temp_clasif = { clasificacion: "", metro: "" };
                this.dialog.closeAll();
            }
        }
    };
    clasificacionComponent.prototype.delete_clasificacion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("clasificacion", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("clasificacion");
        this.rows = JSON.parse(this.actualRow);
    };
    return clasificacionComponent;
}());
export { clasificacionComponent };
